import React, { useState, useEffect, useRef } from "react";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import InmatesLogo from "../../Assets/Logos/InmatesLogo.png";
import issuesLogo from "../../Assets/Logos/IssuesLogo.png";
import bedsOccupied from "../../Assets/Logos/bedsOccupied.png";
import CreateBooking from "../../components/AdminSideComponents/CreateBooking";
import { useNavigate } from "react-router-dom";
import { MdAddCircle } from "react-icons/md";
import axios from "axios";
import EditBooking from "../../components/AdminSideComponents/EditBooking";
import toast from "react-hot-toast";
import deleteIcon from "../../Assets/Logos/checkout/deleteIcon.png";
import editIcon from "../../Assets/Logos/checkout/editIcon.png";
import setPermissionIcon from "../../Assets/Logos/checkout/greenRight.png";
import { formatDate } from "../../utils/dateFormat";

const Booking = () => {
  const [showDropdown, setShowDropdown] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [bookingModal, setBookingModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [bookingsData, setBookingsData] = useState([]);
  const [totalBookings, setTotalBookings] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadEditBooking, setLoadEditBooking] = useState(false);
  const [currentBooking, setCurrentBooking] = useState({});
  const [totalInmates, setTotalInmates] = useState(0);
  const navigate = useNavigate();
  const dropdownRefs = useRef([]);
  const itemsPerPage = 10;
  const [bedCounts, setBedCounts] = useState({});

  const [dropdownPosition, setDropdownPosition] = useState("down");
  // const [allBeds, setAllBeds] = useState([]);

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 200 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  const items = [
    {
      name: "Numbers Of Bookings",
      numberOfItems: totalBookings,
      icon: bedsLogo,
    },
    {
      name: "Numbers Of Beds Occupied",
      numberOfItems: bedCounts?.totalOccupiedBeds || 0,
      icon: bedsOccupied,
    },
    {
      name: "Numbers Of Beds Vacant",
      numberOfItems: bedCounts?.totalVacantBeds || 0,
      icon: issuesLogo,
    },
    {
      name: "Numbers Of Inmates",
      numberOfItems: bedCounts?.totalOccupiedBeds || 0,
      icon: InmatesLogo,
    },
  ];

  // const toggleDropdown = (index) => {
  //   setShowDropdown(showDropdown === index ? null : index);
  // };

  // Fetch bookings data from the backend
  const getBookingByPage = (page) => {
    setIsLoading(true);
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/booking/get_all_booking?page=${page}&limit=${itemsPerPage}&search=${searchTerm}`,
    };

    axios
      .request(config)
      .then((response) => {
        setIsLoading(false);
        console.log("Response of getBookingByPage: ", response.data);
        setBookingsData(response.data.data);
        setTotalBookings(response.data.pagination.totalBookings);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  //Get all beds
  // const getAllBeds = () => {
  //   let config = {
  //     method: "get",
  //     url: `${process.env.REACT_APP_API_URL}/beds/get-all-beds`,
  //   };
  //   axios
  //     .request(config)
  //     .then((response) => {
  //       setIsLoading(false);
  //       console.log("Response of getAllBeds: ", response.data);
  //       setAllBeds(response.data.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getBedCounts = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get_bed_counts`,
      headers: {},
    };
    axios
      .request(config)
      .then((response) => {
        console.log("Response of getBedCounts: ", response.data.data);
        setBedCounts(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getBedCounts();
  }, []);

  //Delete Booking
  const deleteBooking = (id) => {
    if (window.confirm("Are you sure , you want to delete this item ?")) {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/booking/delete_booking/${id}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          toast.success(response.data.message);
          setShowDropdown(null);
          getBookingByPage();
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response.data.message);
        });
    }
  };

  console.log("----->", bookingsData);
  console.log("totalBookings: ", totalBookings);
  // Call the API to fetch data when currentPage or searchTerm changes
  useEffect(() => {
    const timeout = setTimeout(() => {
      getBookingByPage(currentPage);
    }, 800); // Waits for 500ms of inactivity
    return () => clearTimeout(timeout);
  }, [currentPage, searchTerm, bookingModal, loadEditBooking]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown !== null &&
        dropdownRefs.current[showDropdown] &&
        !dropdownRefs.current[showDropdown].contains(event.target)
      ) {
        setShowDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < Math.ceil(totalBookings / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
  };

  return (
    <div className="bookingContainer p-6 bg-primarybgColor ">
      {bookingModal ? (
        <CreateBooking
          bookingModal={bookingModal}
          setBookingModal={setBookingModal}
        />
      ) : (
        ""
      )}

      {loadEditBooking ? (
        <EditBooking
          setLoadEditBooking={setLoadEditBooking}
          currentBooking={currentBooking}
        />
      ) : (
        ""
      )}
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Bookings
      </h1>
      <Cards items={items} />

      <div className="p-4 bg-[#FFFFFF]  mt-6 rounded-lg ">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px] mb-2 lg:mt-0 text-primaryTextColor sm:text-[24px] font-bold">
            Booking List
          </h1>
          <div className="flex items-center gap-1 lg:gap-2 ">
            <div className="relative">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchTerm(e.target.value);
                }}
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />
              {searchTerm && (
                <FaTimes
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor cursor-pointer"
                  onClick={clearSearch}
                />
              )}
            </div>
            <MdAddCircle
              onClick={() => {
                setBookingModal(true);
              }}
              className="text-primaryColor rounded-lg cursor-pointer"
              size={40}
            />
          </div>
        </div>
        <div className="overflow-x-auto  min-h-[70vh]">
          <table className="min-w-full bg-white border-gray-200 rounded-md border-spacing-2 ">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl">
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Mobile No / Email
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Source
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Joining Date
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Booking Amount
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Comments
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-secondaryTextColor tracking-wide gap-4">
              {isLoading ? (
                Array.from({ length: 10 }).map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))
              ) : bookingsData.length === 0 ? (
                <tr>
                  <td
                    colSpan="6"
                    className="py-40 px-6  text-lg text-center text-secondaryTextColor"
                  >
                    No bookings available
                  </td>
                </tr>
              ) : (
                bookingsData.map((booking, index) => (
                  <tr
                    key={index}
                    className="border-b  border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.name}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.mobileNumber}
                      <br />
                      <span className="text-secondaryTextColor">
                        {booking.email}
                      </span>
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.source || "-"}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {formatDate(booking.joiningDate)}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.bookingAmount}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.comments}
                    </td>
                    <td className="py-4 px-6 text-sm hover:text-primaryTextColor text-secondaryTextColor mt-4 relative">
                      <div
                        className="relative"
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div
                            className={`absolute right-0 w-32 bg-white border border-gray-200 rounded-md shadow-lg z-50`}
                          >
                            <ul className="py-1">
                              <li
                                onClick={() => {
                                  navigate(`/create_checkin?id=${booking._id}`);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900  flex gap-2 items-center  hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={setPermissionIcon}
                                  className="h-4 w-4"
                                  alt="checkout"
                                />{" "}
                                Check In
                              </li>
                              <li
                                onClick={() => {
                                  setLoadEditBooking(true);
                                  setCurrentBooking(booking);
                                  toggleDropdown(index);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center  hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="edit"
                                />{" "}
                                Edit
                              </li>
                              <li
                                onClick={() => {
                                  deleteBooking(booking._id);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center   hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="delete"
                                />{" "}
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, totalBookings)} of{" "}
            {totalBookings}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === Math.ceil(totalBookings / itemsPerPage)
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === Math.ceil(totalBookings / itemsPerPage)}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Booking;
